module.exports = __webpack_public_path__ + "img/canvas-mask2.3f7418a5.png";